export const addressLookup = (address: string): Promise<Record<string, string>> => {
	return fetch(`/api/address?address=${address}`).then(response => response.json());
}

export const getAddressById = async (id: string): Promise<Record<string, string>> => {
	return fetch(`/api/findaddress?id=${id}`).then(response => response.json());
}